export enum EDaysOfWeek {
  Monday = 'Monday',
  Tuesday = 'Tuesday',
  Wednesday = 'Wednesday',
  Thursday = 'Thursday',
  Friday = 'Friday',
  Saturday = 'Saturday',
  Sunday = 'Sunday',
}

export interface IDailyAvailabilityTimeItem {
  startTime?: string;
  endTime?: string;
}

export type TDailyAvailabilityItem = Record<
  EDaysOfWeek,
  IDailyAvailabilityTimeItem[]
>;
